import { Component, Element, h, Host, Prop, Watch } from '@stencil/core';
import { unescapeHTML } from '../../global/utility/unescape-html';
import { isMagnoliaEditingMode } from '../../helper';
import { UiCmsFootnoteListBody } from '../ui-cms-debug-component/ui-cms-footnote-list/ui-cms-footnote-list';
import { Link } from '../ui-cms-link/ui-cms-link';
// TODO: Use slot for content

interface UiCmsTextImageVideoBody {
  // headline properties
  headlineLevel: number;
  icon?: string;
  iconOption?: 'icon' | 'none';
  headline: string;
  isHeadlineCentered: boolean;
  variant?: 'white';

  // lead text properties
  leadtext?: string;

  // image properties
  image?: string;
  imageAltText?: string;
  imageMouseover?: string;
  imageCopyright?: string;
  imageCaptionHeadline?: string;
  imageCaption?: string;
  imageSize?: 'small' | 'medium' | 'large' | 'full';
  lightbox?: boolean;

  // video properties
  videoSrc?: string;
  videoCopyright?: string;
  videoLoopSetting?: string;

  // other properties
  text?: string;
  isLeadTextAfterMedia: boolean;
  isTextNotFloating: boolean;
  textColumns?: number;
  mediaSelection: 'none' | 'image' | 'video';
  linkList?: Link[];
  footnotes?: UiCmsFootnoteListBody;
}

@Component({
  tag: 'ui-cms-text-image-video',
  styleUrls: { default: 'ui-cms-text-image-video.scss', editing: 'ui-cms-text-image-video.magnolia.scss' },
})
export class UiCmsTextImageVideo {
  @Element() el: HTMLElement;

  @Prop({ mutable: true }) body: UiCmsTextImageVideoBody = {} as any;

  @Prop({ attribute: 'body' }) utilityBody: string;

  @Prop() variant: 'white';

  @Watch('utilityBody')
  utilityBodyChangeHandler(newValue: string) {
    this.body = newValue ? JSON.parse(newValue) : this.body;
  }

  @Prop({ mutable: true }) i18n = {
    videoEditorInfoMessage: "Im Author-Modus werden Videos in 'Dauerschleife mit Ton' ohne Ton dargestellt.",
  };

  @Prop({ attribute: 'i18n' }) utilityI18n: string;

  @Watch('utilityI18n')
  utilityI18nChangeHandler(newValue: string) {
    if (newValue) this.i18n = { ...this.i18n, ...JSON.parse(newValue) };
  }

  componentWillLoad() {
    this.utilityBodyChangeHandler(this.utilityBody);
    this.utilityI18nChangeHandler(this.utilityI18n);
  }

  render() {
    const videoMutedByEditorMode = isMagnoliaEditingMode() && this.body.videoLoopSetting === 'loop-with-sound';
    return (
      <Host>
        <ui-text-image
          class={`columns-${this.el.closest('ui-cms-grid-element')?.getAttribute('columns')}`}
          level={this.body.headlineLevel}
          icon={this.body.iconOption === 'icon' ? this.body.icon : ''}
          headline={unescapeHTML(this.body.headline)}
          centered={this.body.isHeadlineCentered}
          variant={this.variant}
          leadtext={this.body.leadtext}
          src={this.body.image}
          alt-text={this.body.imageAltText}
          mouseover-text={this.body.imageMouseover}
          copyright-text={this.body.imageCopyright}
          sub-text-headline={this.body.imageCaptionHeadline}
          sub-text={this.body.imageCaption}
          size={this.body.imageSize}
          lightbox={this.body.lightbox}
          text={this.body.text}
          leadtext-after-image={this.body.isLeadTextAfterMedia}
          floating={!this.body.isTextNotFloating}
          text-columns={this.body.textColumns}
          video-src={this.body.videoSrc}
          video-copyright={this.body.videoCopyright}
          video-loop-setting={videoMutedByEditorMode ? 'loop-muted' : this.body.videoLoopSetting || 'no-loop'}
          media-selection={this.body.mediaSelection}
          replace="%RENDITION%"
        >
          {videoMutedByEditorMode ? <p class="video-info-message">{this.i18n.videoEditorInfoMessage}</p> : null}
        </ui-text-image>
        {this.body.footnotes && <ui-cms-footnote-list body={this.body.footnotes} />}
        {this.body.linkList && <ui-cms-link-list body={{ links: this.body.linkList }} />}
      </Host>
    );
  }
}
